:root {
  --lineup-plan-grid-row-name: 1;
  --lineup-plan-grid-row-description: 2;
  --lineup-plan-grid-row-shipment-limit-label: 3;
  --lineup-plan-grid-row-shipment-limit: 4;
  --lineup-plan-grid-row-user-count-label: 5;
  --lineup-plan-grid-row-user-count: 6;
  --lineup-plan-grid-row-analytics-license-label: 7;
  --lineup-plan-grid-row-analytics-license: 8;
  --lineup-plan-grid-row-divider: 9;
  --lineup-plan-grid-row-current-price: 10;
  --lineup-plan-grid-row-select-plan-button: 11;
  --lineup-plan-grid-row-highlights-title: 12;
  --lineup-plan-grid-row-highlights-features: 13;
  --lineup-plan-grid-row-end: 14;
}

.new-lineup-plan-grid-card {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: var(--space-16) var(--space-16) var(--space-32) var(--space-16);

  background: var(--light--background-color--1);
  border: solid 1px var(--default--border-color--12);
  border-radius: 8px;
  margin-bottom: var(--space-24);

  &.merged-with-tabs {
    border-top: none;
    margin-top: 0;
    border-top-left-radius: 0;
  }
}

.annual-toggle {
  justify-content: center;
  margin-bottom: var(--space-12);

  .annual-segment-label {
    display: inline-flex;
    align-items: center;
    gap: var(--space-8);
  }

  .savings-badge {
    padding: var(--space-4) var(--space-8);
    border-radius: 16px;
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
    border: 1px solid var(--grey-800);
    background: var(--grey-100);
    color: var(--grey-800);
  }

  .savings-badge:hover {
    border: 1px solid var(--grey-900);
    color: var(--grey-900);
  }

  :global(.mantine-SegmentedControl-label) {
    display: flex;
    align-items: center;
    height: 34px;
  }

  :global([data-active]) {
    .savings-badge {
      background: var(--grey-800);
      border-color: var(--grey-800);
      color: var(--white);
    }
  }
}

.monthly-switch-error-banner {
  margin-bottom: var(--space-24);
}

.new-lineup-plan-grid {
  display: grid;
}

.plan-headers {
  display: grid;
  grid-column: 1 / -1;
  grid-auto-flow: column;
  row-gap: var(--space-16);
  grid-template-columns: subgrid;
  grid-template-areas:
    'name'
    'description'
    'shipment-limit-label'
    'shipment-limit'
    'user-count-label'
    'user-count'
    'analytics-license-label'
    'analytics-license'
    'divider'
    'current-price'
    'select-plan-button'
    'highlights-title'
    'highlights-features';
}
